import { render, staticRenderFns } from "./IncidentsTypesReportTable.vue?vue&type=template&id=957b1e40&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform"
import script from "./IncidentsTypesReportTable.vue?vue&type=script&lang=js"
export * from "./IncidentsTypesReportTable.vue?vue&type=script&lang=js"
import style0 from "./IncidentsTypesReportTable.vue?vue&type=style&index=0&id=957b1e40&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "957b1e40",
  null
  
)

export default component.exports